import TwoImageFeaturesCta from "@components/TwoImageFeaturesCta"
import { getIn } from "@utils/index"
import React from "react"

import { ContentfulContentBaseProps } from "../types"

interface ContentfulTwoImageFeaturesCtaProps
  extends ContentfulContentBaseProps {}

const ContentfulTwoImageFeaturesCta: React.FC<
  ContentfulTwoImageFeaturesCtaProps
> = ({
  blockId,
  ctaLink,
  ctaText,
  ctaTextMobile,
  description,
  descriptionAlignment,
  featuresList,
  header,
  primaryImage,
  primaryImageCaption,
  secondaryImage,
  secondaryImageCaption,
}) => {
  return (
    <TwoImageFeaturesCta
      blockId={blockId}
      ctaLink={ctaLink}
      ctaText={ctaText}
      ctaTextMobile={ctaTextMobile}
      description={getIn(description, "description")}
      descriptionAlignment={descriptionAlignment}
      featuresList={featuresList || []}
      header={header}
      primaryImage={getIn(primaryImage, "file.url")}
      primaryImageCaption={primaryImageCaption}
      secondaryImage={getIn(secondaryImage, "file.url")}
      secondaryImageCaption={secondaryImageCaption}
    />
  )
}

export default ContentfulTwoImageFeaturesCta
